import { Zap } from "lucide-react";

export const FastBadge = ({ show, testId = "fast-reports-badge", small = false }) => show ? (
  <span className={`inline-flex items-center gap-1 rounded-full bg-[#086B2D]/10 font-semibold text-[#086B2D] whitespace-nowrap ${small ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]"}`} title="80%+ of reports shared within 24 hours of sample collection" data-testid={testId}>
    <Zap className={small ? "h-2.5 w-2.5" : "h-3 w-3"} />Reports in under 24 h</span>) : null;
